import { getUser, getStaticContent, saveGoal, saveQuiz } from "../services/user.services"
import { 
  getDashboard, 
  saveTerms,
  saveFaqs,
  getLoginsReport
} from "../services/dashboard.services"
import { isLoggedIn } from "../services/auth.services.js"
import { redeem, downloadRedeem, getDepartments, getCities, getSites } from "../services/redemptions.services.js"


export const isLog = async function(token) {
  return new Promise((resolve) => {

    isLoggedIn({ token: token }).then((res) => {
      resolve(res)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtUser = async function(token) {
  return new Promise((resolve) => {

    getUser({ token: token }).then((user) => {

      resolve(user)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtStaticContent = async() => {
  return new Promise((resolve) => {

    getStaticContent().then((content) => {

      resolve(content)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const doRedeem = async function(token, price, id_award, quantumName, quantumDoc, quantum_site) {
  return new Promise((resolve) => {

    redeem({ token, price, id_award, quantumName, quantumDoc, quantum_site }).then((data) => {      

      if (data && data.status === 200) {
        const file = data.file ? data.file : data.data.file
        const mime = data.headers ? data.headers['Content-Type'] : data.data.headers['Content-Type']
        const ext = mime.includes('pdf') ? 'pdf' : 'zip'
        const name = `boleta.${ext}`
        var a = document.createElement("a")
        a.href = file.includes('data') ? file : `data:${mime};base64,${file}`
        
        a.download = name
        a.click()

        resolve({
          status: 200,
          file: name,
          data: data.detail
        })

      } else {
        resolve({
          status: 400,
          data: data.detail
        })
      }

    }).catch(error => {
      resolve(error)
    })
  })
}

export const doloadRedeem = async function(id_redemtion, token) {
  return new Promise((resolve) => {
    downloadRedeem({ token: token, id: id_redemtion }).then((data) => {
      if (data && data.status === 200) {
        const file = data.data.file;

        if (data.data.headers) {
          const mime = data.data.headers['Content-Type'];
          const isPDF = mime.includes('pdf');
          const ext = isPDF ? 'pdf' : 'zip';
          const name = `boleta.${ext}`;
          const fileUrl = file.includes('data') ? file : `data:${mime};base64,${file}`;

          if (isPDF) {
            let base64String = fileUrl;
            if (fileUrl.startsWith("data:")) {
              base64String = fileUrl.split(',')[1];
            }
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.location.href = blobUrl;
            
          } else {
            // Si no es PDF, se sigue descargando
            const a = document.createElement("a");
            a.href = fileUrl;
            a.download = name;
            a.click();
          }

          resolve({
            status: 200,
            file: name,
            data: data.detail
          });

        } else {
          resolve({
            status: 400,
            data: 'Bono no encontrado'
          });
        }

      } else {
        resolve({
          status: 400,
          data: data.detail
        });
      }
    }).catch(error => {
      resolve(error);
    });
  });
}

export const gtDashboard = async function(code) {
  return new Promise((resolve) => {

    getDashboard({ code: code }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const svTerms = async function(code, data) {
  return new Promise((resolve) => {

    saveTerms({ code: code, data: data }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const svFaqs = async function(code, data) {
  return new Promise((resolve) => {

    saveFaqs({ code: code, data: data }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtDepartments = async function(token, brand_id) {
  return new Promise((resolve) => {

    getDepartments({ token: token, brand_id: brand_id}).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtCities = async function(token, brand_id, department_id) {
  return new Promise((resolve) => {

    getCities({ token: token, brand_id: brand_id, department_id: department_id}).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtSities = async function(token, brand_id, department_id, city_id) {
  return new Promise((resolve) => {

    getSites({ token: token, brand_id: brand_id, department_id: department_id, city_id: city_id}).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const stGoal = async function(token, amount, trx, award, awardName) {
  return new Promise((resolve) => {

    saveGoal({ token: token, amount, trx, award, awardName }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const gtLoginsReport = async function(code, action, date) {
  return new Promise((resolve) => {

    getLoginsReport({ code: code, action: action, date: date }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}

export const stQuiz = async function(token, respond_1, respond_2) {
  return new Promise((resolve) => {

    saveQuiz({ token: token, respond_1: respond_1, respond_2: respond_2 }).then((data) => {

      resolve(data)
    }).catch(error => {
      resolve(error)
    })
  })
}
